import styled from '@emotion/styled';
import { StripedDataTableWrapper } from '../common.StyledComponents';

// Fixed percent widths so every template table and its skeleton line up, whatever the labels.
export const COLUMN_WIDTH_PERCENT = { status: 8, actions: 18 };

export const toWidth = (percent: number) => `${percent}%`;

export const getLabelWidthPercent = (extraColumnWidths: number[]) =>
    100 -
    COLUMN_WIDTH_PERCENT.status -
    COLUMN_WIDTH_PERCENT.actions -
    extraColumnWidths.reduce((sum, width) => sum + width, 0);

export const HIGHLIGHT_ROW_CLASS = 'template-row-highlight';

const HIGHLIGHT_RING = '#0000ee';
const HIGHLIGHT_RADIUS = '10px';
const ringEdge = (offset: string) => `inset ${offset} ${HIGHLIGHT_RING}`;

// A table row can't take a border radius, so the cells draw the ring: top and bottom edges on every cell, and
// the side edges and rounded corners on the first and last. The extra & beats the striped rows' own background.
export const HighlightableRows = styled(StripedDataTableWrapper)`
    &&& .p-datatable .p-datatable-tbody > tr.${HIGHLIGHT_ROW_CLASS} > td {
        background: #e8f0fe;
        box-shadow: ${ringEdge('0 2px 0')}, ${ringEdge('0 -2px 0')};
    }

    &&& .p-datatable .p-datatable-tbody > tr.${HIGHLIGHT_ROW_CLASS} > td:first-child {
        border-radius: ${HIGHLIGHT_RADIUS} 0 0 ${HIGHLIGHT_RADIUS};
        box-shadow: ${ringEdge('2px 0 0')}, ${ringEdge('0 2px 0')}, ${ringEdge('0 -2px 0')};
    }

    &&& .p-datatable .p-datatable-tbody > tr.${HIGHLIGHT_ROW_CLASS} > td:last-child {
        border-radius: 0 ${HIGHLIGHT_RADIUS} ${HIGHLIGHT_RADIUS} 0;
        box-shadow: ${ringEdge('-2px 0 0')}, ${ringEdge('0 2px 0')}, ${ringEdge('0 -2px 0')};
    }
`;

export const ActionsRow = styled.div`
    margin-bottom: 16px;
`;

export const LabelWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const PencilButton = styled.button`
    display: inline-flex;
    align-items: center;
    padding: 4px;
    border: 0;
    background: none;
    color: #6b7280;
    cursor: pointer;

    // PrimeIcons size in rem, which design-system's html{font-size:50%} halves.
    .pi {
        font-size: 14px;
    }

    &:hover {
        color: #0891b2;
    }

    &[aria-disabled='true'] {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const ActionsSkeletonRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DisabledButtonTitleWrap = styled.span`
    display: inline-block;
`;
